import { createContext } from 'react';
import { string } from 'prop-types';

type ContextType = {
  i18n: null;
  t: Function;
};

function getDefautlContextState(): ContextType {
  return {
    i18n: null,
    t: () => {},
  };
}

export const TranslationContext = createContext(getDefautlContextState());

export const AppContext = createContext({
  isLoading: false,
  sendInput: string,
  dispatch: () => {},
});
